import React from "react";
import { useSelector } from "react-redux";
import { Route, Redirect } from "react-router-dom";

const AuthRoute = ({ component: Component, admin, ...rest }) => {
  const auth = useSelector(store => store.user.user);
  // TODO connecting it to real data when the service is ready
  const isAdmin = true;

  return (
    <Route
      {...rest}
      render={props => {
        if (!auth?.token) return <Redirect to={{ pathname: "/login" }} />;
        if (admin && !isAdmin) return <Redirect to={{ pathname: "/" }} />;
        return <Component {...props} />;
      }}
    />
  );
};

export default AuthRoute;
